import { useCallback } from 'react';
import { useSettings } from '@/entities/settings';

/** Ширина развёрнутого меню навигации по атрибутам по умолчанию, px. */
export const DEFAULT_NAVIGATION_WIDTH = 208;

/** Меню уже этой ширины не читается: наименования узлов рвутся на строки из одного-двух слов. */
export const MIN_NAVIGATION_WIDTH = 160;

/** Шире этой ширины меню отнимает у значений атрибутов место, нужное им самим. */
export const MAX_NAVIGATION_WIDTH = 480;

/**
 * Результат {@link useNavigationWidth}.
 */
export type NavigationWidth = {
  /** Ширина развёрнутого меню навигации по атрибутам, px. */
  navigationWidth: number;
  /** Сохраняет новую ширину меню навигации. */
  setNavigationWidth: (width: number) => void;
};

/**
 * Ширина развёрнутого меню навигации по атрибутам.
 *
 * Ширина — настройка пользователя: её подбирают под длину наименований атрибутов проекта,
 * поэтому она хранится в настройках интерфейса рядом со свёрнутостью меню и переживает
 * переход к другому диалогу и следующий вход. Хранится отклонение от умолчания: нет записи —
 * меню открывается шириной, заданной системой.
 */
export const useNavigationWidth = (): NavigationWidth => {
  const { dialogsPage, setDialogsSettings } = useSettings();

  const setNavigationWidth = useCallback(
    (width: number) => {
      setDialogsSettings({ attrNavWidth: width });
    },
    [setDialogsSettings],
  );

  return { navigationWidth: dialogsPage.attrNavWidth ?? DEFAULT_NAVIGATION_WIDTH, setNavigationWidth };
};
